module.exports = __webpack_public_path__ + "img/b4144c5.png";